import React from 'react';
import { List, ListItem } from '../../components/List';
import { ArrowColumn, BustypeTextContainer } from '../../components/Stage';
import { SvgIcon } from '../../components/SvgIcon';
import { Title } from '../../components/Title';
import Typo3Label from '../../provider/Typo3Provider/Typo3Label';

const BustypeContent = () => (
  <ArrowColumn noGap large={5} medium={12} small={12} bg="secondary">
    <BustypeTextContainer>
      <Title.BusTypeSelect>
        <Typo3Label label="busSelect.headline" />
      </Title.BusTypeSelect>
      <List>
        <ListItem>
          <SvgIcon icon="check" />{' '}
          <span>
            <Typo3Label label="busSelect.pointOne" />
          </span>
        </ListItem>
        <ListItem>
          <SvgIcon icon="check" />{' '}
          <span>
            <Typo3Label label="busSelect.pointTwo" />
          </span>
        </ListItem>
        <ListItem>
          <SvgIcon icon="check" />{' '}
          <span>
            <Typo3Label label="busSelect.pointThree" />
          </span>
        </ListItem>
      </List>
    </BustypeTextContainer>
  </ArrowColumn>
);

export default BustypeContent;
